// extracted by css-extract-rspack-plugin
export default {"cls1":"ActiveState-cls1_Ar7","cls2":"ActiveState-cls2_d4H ActiveState-cls1_Ar7"};